// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"604":"adb60fb5","787":"b7b100f2"}[chunkId] + ".chunk.js";
};